import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { MethodistSlide } from '../../components/base/MethodistSlide';
import { NexusAdminLayout } from '../../components/nexus/NexusAdminLayout';
import GovernanceUI from '../ui-samples/GovernanceUI';

interface GovernanceSlideProps {
  captionsText?: string;
  isSpeaking?: boolean;
  showCaptions?: boolean;
}

const GovernanceSlide: React.FC<GovernanceSlideProps> = ({
  captionsText,
  isSpeaking,
  showCaptions,
}) => {
  return (
    <MethodistSlide
      captionsText={captionsText}
      isSpeaking={isSpeaking}
      showCaptions={showCaptions}
      showLogo={true}
      title="Platform Governance"
    >
      <NexusAdminLayout
        title="Nexus: Platform Governance"
        activeSection="governance"
        userName="Dr. Michael Thompson"
        userRole="Chief Governance Officer"
      >
        <GovernanceUI />
      </NexusAdminLayout>
    </MethodistSlide>
  );
};

export default GovernanceSlide;
